export class WorksheetsStatusByOperativeUnitDto {
  operativeUnitId: string;
  operativeUnitCode: string;
  operativeUnitName: string;
  totalWorksheets: number;
  nonValidatedWorksheets: number;
}
